import { getApiKeys, generateApiKey, updateKeyStatus, getBalance, recharge, changePassword } from '@/api/account'

const state = {
  apiKeys: [],
  loading: false,
  balance: 0
}

const mutations = {
  SET_LOADING: (state, isLoading) => {
    state.loading = isLoading
  },
  SET_API_KEYS: (state, keys) => {
    state.apiKeys = keys.map(key => ({ ...key, showSecret: false }))
  },
  ADD_API_KEY: (state, key) => {
    state.apiKeys.unshift({ ...key })
  },
  SET_BALANCE: (state, balance) => {
    state.balance = balance
  },
  UPDATE_KEY_STATUS: (state, { id, status }) => {
    const key = state.apiKeys.find(k => k.id === id)
    if (key) {
      key.status = status
    }
  },
  SET_KEY_VISIBILITY: (state, { index, visible }) => {
    if (state.apiKeys[index]) {
      state.apiKeys[index].showSecret = visible
    }
  }
}

const actions = {
  // 获取API密钥列表
  async getApiKeys({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await getApiKeys()
      if (response.code === 0) {
        commit('SET_API_KEYS', response.data || [])
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 生成新的API密钥
  async generateApiKey({ commit }) {
    const response = await generateApiKey()
    if (response.code === 0 && response.data) {
      commit('ADD_API_KEY', response.data)
    }
    return response
  },

  // 更新API密钥状态
  async updateKeyStatus({ commit }, { id, status }) {
    const response = await updateKeyStatus(id, status)
    if (response.code === 0) {
      commit('UPDATE_KEY_STATUS', { id, status })
    }
    return response
  },

  // 切换密钥可见性
  setKeyVisibility({ commit }, { index, visible }) {
    commit('SET_KEY_VISIBILITY', { index, visible })
  },

  // 获取余额
  async getBalance({ commit }) {
    const response = await getBalance()
    if (response.code === 0 && response.data) {
      commit('SET_BALANCE', parseFloat(response.data.balance))
    }
    return response
  },

  // 充值
  async recharge({ dispatch }, data) {
    const response = await recharge(data)
    if (response.code === 0) {
      await dispatch('getBalance')
    }
    return response
  },

  // 修改密码
  async changePassword(_, data) {
    const response = await changePassword(data)
    return response
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
